<script>
import _ from 'lodash';
import i18nMixin from '@/mixins/i18n.mixin.js';
import { h, resolveComponent, resolveDirective, withDirectives } from 'vue';

export default {
  mixins: [i18nMixin],
  name: 'cNavi',
  emits: ['lnbToggle', 'itemClick', 'itemDelete', 'opened', 'onchange'],
  props: {
    lnbClosed: {
      type: Boolean,
      default: true
    },
    modelValue: {
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      default: ''
    },
    activeItemId: {
      type: String,
      default: ''
    },
    count: {
      type: Boolean,
      default: false
    },
    width: {
      type: Number,
      default: undefined
    },
    reverse: {
      type: Boolean,
      default: false
    },
    menuType: {
      type: String,
      default: 'lnb',
      validator: function (value) {
        return ['lnb', 'calculator'].indexOf(value) !== -1;
      }
    },
    autoComplete: {
      type: Boolean,
      default: false
    },
    autoCompletePlaceholder: {
      type: String,
      default: ''
    },
    autoClose: {
      type: Boolean,
      default: true
    },
    activeTarget: {
      type: String,
      default: ''
    },
    itemType: {
      type: Boolean,
      default: false
    },
    itemIcon: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      autoCompleteText: '',
      searchList: [],
      filteredItemList: [],
      isActive: false,
      childrenActive: false
    };
  },
  mounted() {
    this.onFilter();
    this.setParentId();
  },
  watch: {
    activeItemId: {
      deep: true,
      handler() {
        if (this.autoClose) {
          this.itemAllClose(this.modelValue);
        }
        this.setParentId();
      }
    },
    modelValue: {
      deep: true,
      handler() {
        this.onFilter();
      }
    }
  },
  computed: {
    textcolor() {
      const { menuType, isActive, childrenActive, $theme } = this;
      if (menuType === 'lnb') {
        return childrenActive ? $theme.COLOR.UI.WHITE : '#2F3237';
      }
      return '';
    },
    iconcolor() {
      const { menuType, childrenActive, $theme } = this;
      if (menuType === 'lnb') {
        return childrenActive ? $theme.COLOR.UI.WHITE : '#B6C6F2';
      }
      return '';
    }
  },
  methods: {
    iconBind(item) {
      if (item.icon) {
        return item.icon;
      }
      if (item.id === 'product_state') {
        return 'checkbox';
      } else if (item.id === 'paas') {
        return 'bell';
      } else if (item.id === 'mb_state') {
        return 'thumbnail_view';
      }
      return item.name
        .toLowerCase()
        .replace(/[(&-\s]/gi, '_')
        .replaceAll(')', '');
    },
    setParentId() {
      this.modelValue.map((item, index) => {
        if (item.children) {
          this.childIdAdd(item, index, this.activeItemId, item.id);
        }
      });
    },
    depsPad(val, productBl) {
      if (val === 1) {
        return this.menuType === 'lnb' ? 12 : 24;
      } else if (val === 2) {
        return this.menuType === 'lnb' ? (productBl ? 30 : 40) : 32;
      } else {
        return 76;
      }
    },
    childIdAdd(item, index, val, groupId) {
      item.children.map((cItem, cindex) => {
        cItem['parentId'] = item.id;
        cItem['groupId'] = groupId;

        const activeTargetCheck =
          this.activeTarget && cItem.id === val && this.activeTarget === cItem.groupId;
        const normalCheck = !this.activeTarget && cItem.id === val;
        if (activeTargetCheck || normalCheck) {
          this.modelValue[index].open = true;
          cItem['open'] = true;
        }

        if (cItem.children) {
          cItem.children.map((item, sindex) => {
            item['parentId'] = cItem.id;
            item['groupId'] = groupId;
            const activeTargetCheckChild =
              this.activeTarget && item.id === val && this.activeTarget === item.groupId;
            const normalCheckChild = !this.activeTarget && item.id === val;

            if (activeTargetCheckChild || normalCheckChild) {
              this.modelValue[index].open = true;
              this.modelValue[index].children[cindex].open = true;
              item['open'] = true;
            }

            if (item.children) {
              this.childIdAdd(item, sindex, this.activeItemId, groupId);
            }
          });
        }
      });
    },
    itemClick(item) {
      if (item.children) {
        this.itemOpenToggle(item);
        if (this.lnbClosed) {
          this.$emit('lnbToggle');
        }
      } else {
        this.$emit('itemClick', item);
      }
    },
    deleteItem(e, item) {
      e.stopPropagation();
      this.$emit('itemDelete', item);
    },
    openNewTab(e, item) {
      const newUrl = `${window.location.origin}${window.location.pathname}#${item.url}`;
      window.open(newUrl, '_blank');
      e.stopPropagation();
    },
    itemAllClose(items) {
      items.forEach((item, index) => {
        item['open'] = false;
        if (item.children) {
          this.itemAllClose(item.children);
        }
      });
    },
    itemSameDepthClose(list, item) {
      list.forEach((listItem, index) => {
        if (listItem.id === item.id) {
          this.itemAllClose(list);
        } else {
          if (listItem.children) {
            this.itemSameDepthClose(listItem.children, item);
          }
        }
      });
    },
    itemOpenToggle(item) {
      if (!item.open && this.autoClose) {
        this.itemSameDepthClose(this.modelValue, item);
      }
      if ((!this.lnbClosed && !item.open) || (this.lnbClosed && item.open)) {
        item.open = true;
      } else {
        item.open = !item.open;
      }

      this.$forceUpdate();
      this.$emit('opened', item);
    },
    haveActiveChild(item) {
      let childrenActive = false;

      item.children.forEach((child) => {
        if (child.children) {
          childrenActive = this.haveActiveChild(child);
        } else if (child.id === this.activeItemId) {
          childrenActive = true;
        }
      });
      return childrenActive;
    },
    change(val) {
      this.onReset();
      this.onFilter(val);
      this.autoCompleteText = val;
      this.$emit('onchange', val);
    },
    onFilter(val) {
      if (val) {
        const newChild = this.filteredItemList.filter((item) => {
          return item.name.toLowerCase().indexOf(val.toLowerCase()) > -1;
        });
        this.filteredItemList = newChild;
      } else {
        if (this.autoComplete) {
          this.onReset();
        }
      }
    },
    onReset() {
      const searchList = [];
      this.modelValue.filter((item) => {
        if (item.children.length > 0) {
          searchList.push(...item.children);
        }
      });
      this.filteredItemList = _.cloneDeep(searchList);
    }
  },
  render() {
    const {
      title,
      activeItemId,
      count,
      width,
      itemClick,
      haveActiveChild,
      $theme,
      menuType,
      autoComplete,
      autoCompletePlaceholder,
      filteredItemList,
      autoCompleteText,
      modelValue,
      itemIcon,
      lnbClosed
    } = this;

    const searchItem = (itemList) =>
      filteredItemList.length > 0
        ? itemList.map((item, index) => {
            const isActive = activeItemId === item.id;
            return h('li', {
              key: index,
              class: ['c-navi-sch-item', isActive && 'active'],
              onClick: () => itemClick(item),
              innerHTML:
                this.autoCompleteText.length > 0
                  ? item.name.replace(
                      new RegExp(this.autoCompleteText, 'i'),
                      `<span class="point">${item.name.substr(
                        item.name.search(new RegExp(this.autoCompleteText, 'i')),
                        this.autoCompleteText.length
                      )}</span>`
                    )
                  : item.name
            });
          })
        : h('li', { class: ['c-navi-sch-item', 'no-result'] }, () => [
            this.t('label.noSearchResult')
          ]);
    const cLabel = resolveComponent('c-label');
    const legoIcon = resolveComponent('lego-icon');
    const legoTextField = resolveComponent('lego-text-field');
    const cScroll = resolveComponent('c-scroll');
    const legoTooltip = resolveDirective('lego-tooltip');
    const naviItem = (itemList, depth, deleteControl) =>
      itemList.map((item, index) => {
        let isActive = false;

        if (this.activeTarget) {
          if (activeItemId === item.id && this.activeTarget === item.groupId) {
            isActive = true;
          }
        } else {
          if (activeItemId === item.id) isActive = true;
        }

        let childrenActive = false;

        let childItems;
        if (item.children) {
          childItems = item.children;
          childrenActive = haveActiveChild(item);
        }
        return h(
          'li',
          {
            key: index,
            class: [
              'c-navi-item',
              item.hide ? 'hide' : '',
              item.line ? 'c-line-item' : '',
              lnbClosed ? 'lnb-close' : ''
            ]
          },
          [
            h(
              'div',
              {
                class: [
                  'c-navi-item-text',
                  isActive && 'active',
                  !lnbClosed && item.open && childItems && 'open',
                  childrenActive && 'active-tab',
                  childItems && 'have-children',
                  item.parentMenuSq == '0' && lnbClosed && childrenActive && 'active'
                ],
                onClick: () => itemClick(item),
                style: [
                  {
                    paddingLeft: this.depsPad(depth, itemIcon && item.type === 'PRODUCT') + 'px'
                  }
                ]
              },
              [
                h(
                  cLabel,
                  {
                    class: [(childrenActive || isActive) && 'active-color'],
                    icon: itemIcon && depth === 1 ? this.iconBind(item) : '',
                    iconType: 'picto',
                    weight: isActive || childrenActive ? 700 : 400,
                    color: !childrenActive ? this.textcolor : '#B6C6F2',
                    ellipsis: true,
                    width: '100%',
                    size: 14,
                    isLnb: true
                  },
                  () => [
                    item.name,
                    (count || item.childlength) &&
                      depth === 1 &&
                      childItems &&
                      ` (${childItems.length})`
                  ]
                ),

                deleteControl &&
                  h(legoIcon, {
                    icon: 'delete',
                    size: 16,
                    color: this.iconcolor,
                    iconType: 'df',
                    onClick: (e) => this.deleteItem(e, item)
                  }),
                !lnbClosed &&
                  item.newTab &&
                  withDirectives(
                    h(legoIcon, {
                      class: 'scpm-new-tab',
                      icon: 'scpm_new_tab',
                      style: { visibility: 'hidden', paddingLeft: '5px', marginTop: '1px' },
                      size: 16,
                      color: this.iconcolor,
                      iconType: 'df',
                      onClick: (e) => this.openNewTab(e, item)
                    }),
                    [[legoTooltip, this.t('message.openNewTab')]]
                  ),
                childItems &&
                  h(legoIcon, {
                    icon: this.reverse ? 'arrow_up' : 'arrow_down',
                    size: 18,
                    color: '#2E3138 !important',
                    iconType: 'df'
                  }),

                menuType === 'calculator' &&
                  depth === 2 &&
                  h(legoIcon, {
                    icon: 'add_box_solid',
                    size: 16,
                    color: this.iconcolor,
                    iconType: 'df'
                  })
              ]
            ),
            childItems &&
              item.open &&
              !lnbClosed &&
              h(
                'ul',
                {
                  class: `c-navi-child-items${depth + 1}`
                },
                [
                  childItems.length === 0 && item.blankMsg
                    ? h(
                        'li',
                        {
                          class: 'blank-msg'
                        },
                        [item.blankMsg]
                      )
                    : naviItem(childItems, depth + 1, item.childDeleteControl)
                ]
              )
          ]
        );
      });

    const naviItems = h('ul', { class: 'c-navi-items' }, [
      autoCompleteText.length > 0 ? searchItem(filteredItemList, 1) : naviItem(modelValue, 1)
    ]);
    const naviTitle = h('div', { class: 'c-navi-title' }, [
      h(
        cLabel,
        {
          weight: 700,
          color: $theme.COLOR.UI.UI06
        },
        [title]
      )
    ]);
    const naviList = h('div', { class: 'c-navi-list' }, [title && naviTitle, naviItems]);
    return h(
      'div',
      {
        class: [{ 'c-navi': true }, `c-navi-${menuType}`],
        style: {
          width: `${width}px`
        }
      },
      [
        autoComplete &&
          h(
            'div',
            {
              class: 'c-navi-autocomplete'
            },
            [
              h(legoTextField, {
                searchable: true,
                clearable: true,
                value: this.autoCompleteText,
                placeholder: autoCompletePlaceholder,
                onInput: this.change
              })
            ]
          ),
        h(
          cScroll,
          {
            style: {
              height: autoComplete ? 'calc(100% - 49px)' : '100%'
            },
            ref: 'scrollNavi'
          },
          () => [naviList]
        )
      ]
    );
  }
};
</script>

<style lang="scss" scoped>
$naviTypes: ('lnb', 'calculator');
$menuActionColor: rgba(239, 241, 251, 1);
$menuTextColor: #2f3237;
@mixin menuType($val) {
  @if $val == lnb {
    .active-color {
      :deep(.lego-icon--picto) {
        opacity: 1 !important;
      }
    }
    .c-line-item {
      height: 1px;
      background-color: #fff;
      opacity: 0.1;
      overflow: hidden;
    }
    .c-navi-item-text {
      .c-label {
        :deep .lego-icon--picto {
          opacity: 1;
        }
      }

      &:hover {
        .c-label {
          color: $menuTextColor !important;
        }

        :deep .scpm-new-tab {
          visibility: visible !important;
        }

        background-color: $menuActionColor;
      }

      &.active-tab {
        .c-label {
          color: $menuTextColor !important;
          font-weight: 500 !important;
        }
        :deep .lego-icon {
          color: #2c5ad8 !important;
        }
      }

      &.active {
        background-color: #e1e7f9;

        .c-label {
          color: #374fc8 !important;
        }

        :deep .lego-icon {
          color: #2c5ad8 !important;
        }
      }

      :deep .lego-icon {
        color: #b6c6f2;

        & + .lego-icon {
          margin-left: 6px;
        }
      }
    }
    .c-navi-child-items2 {
      &:after {
        background-color: #1f2430;
      }

      .c-navi-item-text {
        &:hover {
          background-color: $menuActionColor;
        }

        &.open {
          background-color: red;
        }

        &.active {
          background-color: #e1e7f9;
        }
      }

      .blank-msg {
        height: 116px;
        color: rgba($color--ui-white, 0.6);
        display: flex;
        align-items: center;
        justify-content: center;
        background: rgba($color--ui-white, 0.04);
        margin-bottom: -16px;
        font-size: 12px;
        white-space: pre;
        text-align: center;
      }

      > li {
        &:last-child {
          .c-navi-child-items3 {
            > li {
              &:last-child {
                position: relative;
                margin-bottom: -16px;

                &:after {
                  bottom: -16px;
                }
              }
            }
          }
        }
      }
    }
    .c-navi-child-items3 {
      &:after {
        background-color: #272c37;
      }

      .c-navi-item-text {
        background-color: #272c37;

        &:hover {
          background-color: #313540;
        }

        &.active {
          background-color: #2f3b6e;
        }
      }

      > li {
        &:after {
          content: '';
          position: absolute;
          bottom: 0;
          width: 100%;
          left: 0;
          height: 16px;
          background: #272c37;
        }
      }
    }
  } @else {
    padding: 20px;

    .c-navi-item-text {
      height: 40px;

      :deep .opus-icon__add_box_solid {
        display: none;
      }

      &:hover {
        background-color: rgba($color--primary, 0.04);

        :deep .opus-icon__add_box_solid {
          display: block;
        }
      }

      &:active {
        background-color: rgba($color--primary, 0.12);
      }
    }

    .c-navi-autocomplete {
      padding-bottom: 8px;
      border-bottom: 1px solid $color--ui08;
      margin-bottom: 8px;
    }
  }
}

.c-navi {
  width: 100%;

  .c-navi-list > ul > li > .c-navi-item-text {
    height: 40px;
    margin: 8px 0;

    .c-label {
      font-weight: 700 !important;
    }
  }

  .c-navi-list {
    .c-navi-items .c-navi-item:last-child {
      border-bottom: none;
    }

    .c-navi-items {
      .c-navi-item {
        &.lnb-close {
          height: 56px;
          border-bottom: unset;

          .c-navi-item-text {
            height: 56px;
            margin: 0 8px;
            padding-left: 12px !important;

            &.active {
              padding-left: 16px !important;
              background-color: unset;
              border-left: 4px solid #374fc8;
              border-radius: unset;
              margin: unset !important;
            }
          }
        }
      }
    }
  }

  &-sch-item {
    height: 32px;
    padding: 6px 12px;
    cursor: pointer;

    :deep .point {
      color: $color--primary-tint06;
    }

    &:hover {
      background-color: rgba($color--primary, 0.04);
    }

    &:active {
      background-color: rgba($color--primary, 0.12);
    }

    &.no-result {
      pointer-events: none;
    }
  }

  @each $naviType, $i in $naviTypes {
    &-#{$naviType} {
      @include menuType($naviType);
    }
  }

  &-item-text {
    &.open {
      :deep .lego-icon {
        &.opus-icon__arrow_down {
          transform: rotate(-180deg);
        }
      }
    }

    :deep .opus-icon__delete {
      display: none;
    }

    &:hover {
      :deep .opus-icon__delete {
        display: inline-block;
        margin-left: 12px;
      }
    }
  }

  :deep .simplebar-track.simplebar-vertical {
    right: 5px;
  }

  &-item {
    border-bottom: solid 1px #e3e4e8;

    &.hide {
      display: none;
    }
  }

  &-title {
    display: flex;
    align-items: center;
    padding: 0 12px 0 19px;
    margin-bottom: 4px;
  }

  &-item-text {
    display: flex;
    align-items: center;
    padding: 8px 8px 8px;
    cursor: pointer;
    border-radius: 4px;
  }

  &-item-text,
  &-title {
    height: 56px;
  }

  &-child-items {
    padding: 4px 0;
  }

  .c-navi-child-items2 {
    padding-bottom: 16px;
    position: relative;

    .c-navi-item-text {
      height: 36px;
    }

    .c-navi-item {
      border-bottom: unset;
    }
  }

  .c-navi-child-items3 {
    padding-bottom: 16px;
    position: relative;

    .c-navi-item-text {
      height: 32px;

      .c-label {
        font-size: 14px !important;
        padding-right: 28px;
      }
    }

    .c-navi-item {
      border-bottom: unset;
    }
  }
}
</style>
